__turbopack_context__.v({
  "primary_btn": "Buttons-module-scss-module__zP5tKa__primary_btn",
  "secoundary_btn": "Buttons-module-scss-module__zP5tKa__secoundary_btn",
  "ternary_btn": "Buttons-module-scss-module__zP5tKa__ternary_btn",
});
